import { api } from '../api';

/**
 * Uma opção de instituição para o cadastro de paciente. Projeção pobre de propósito,
 * do lado do back também (id + nome): é lista de select, não cadastro.
 */
export interface AssignableInstitution {
  id: string;
  name: string;
}

/**
 * As instituições em que **este** usuário pode cadastrar paciente (tarefa 0.30).
 *
 * ⚠️ **Não é `findInstitutionsByFilter`**, e a diferença é a regra de produto: aquela
 * rota exige `list_institutions`, que só o `administrator` tem, então ela responde 403
 * para `assistant` — que **pode** cadastrar paciente. Esta é derivada do escopo do
 * token: o administrador recebe todos os municípios, e todo outro papel recebe só o
 * do próprio vínculo. Quem monta a lista é o servidor, para que a tela não ofereça uma
 * opção que o `POST /patients` depois recusa com 403.
 */
export const listAssignableInstitutions = async (): Promise<
  AssignableInstitution[]
> => {
  const { data } = await api.get('/institutions/assignable');

  return data;
};
